(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["golden-kids-product-accordions"] && !Shopify.designMode) return;
  try {
    class GoldenKidsPolicyContent extends HTMLElement {
    connectedCallback() {
      // Shopify policy HTML can retain metadata from the editor it was pasted from.
      // Work only on the rendered policy DOM; never interpret plain-text fields as HTML.
      queueMicrotask(() => {
        this.querySelectorAll('*').forEach((element) => {
          element.removeAttribute('data-start');
          element.removeAttribute('data-end');
          if (element.getAttribute('dir') === 'auto') element.removeAttribute('dir');
          for (const className of Array.from(element.classList)) {
            if (/selectionAnchor/i.test(className)) element.classList.remove(className);
          }
          if (element.hasAttribute('class') && !element.className) element.removeAttribute('class');
        });

        this.querySelectorAll('a:not([href])').forEach((anchor) => {
          const address = anchor.textContent.trim();
          if (/^[A-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Z0-9-]+(?:\.[A-Z0-9-]+)+$/i.test(address)) {
            anchor.setAttribute('href', `mailto:${address}`);
          }
        });
      });
    }
  }

  if (!customElements.get('gk-policy-content')) {
    customElements.define('gk-policy-content', GoldenKidsPolicyContent);
  }
  } catch(e) { console.error(e); }
})();

})();
